var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.13,
    height: 26.13,
    viewBox: "0 0 26.13 26.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_801_",
    transform: "translate(0 -0.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    d: "M10.594,99.73H5.348a.422.422,0,0,0-.421.422v16.889a.422.422,0,0,0,.421.422h5.246a.422.422,0,0,0,.421-.422V100.152A.422.422,0,0,0,10.594,99.73Z",
    transform: "translate(-4.512 -90.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    d: "M3.461.341A3.466,3.466,0,1,0,6.92,3.806,3.467,3.467,0,0,0,3.461.341Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    d: "M116.651,94.761a6.155,6.155,0,0,0-4.609,1.939V95.6a.422.422,0,0,0-.421-.422H106.6a.422.422,0,0,0-.421.422v16.889a.422.422,0,0,0,.421.422h5.234a.422.422,0,0,0,.421-.422v-8.356c0-2.816.763-3.913,2.722-3.913,2.133,0,2.3,1.759,2.3,4.058v8.211a.422.422,0,0,0,.421.422h5.236a.422.422,0,0,0,.421-.422v-9.264C123.356,99.041,122.56,94.761,116.651,94.761Z",
    transform: "translate(-97.226 -86.444)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6ba0e59a0974161bdc073771d95ad780.svg";
export { ForwardRef as ReactComponent };